
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30818',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30818",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.55354",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8359",
  "hubspot-dlb": "static-2.1882",
  "HubStyleTokens": "static-2.11817",
  "I18n": "static-7.1678",
  "quartz": "static-1.7489",
  "quartz-config": "static-1.1267",
  "quartz-core": "static-1.6708",
  "react-dlb": "static-1.89",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.80",
  "reselect": "static-3.12",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.950",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.55341",
  "feedback-utils": "static-1.55345",
  "forms-embed-utils-lib": "static-1.4793",
  "forms-utils-lib": "static-1.13124",
  "foundations-assets": "static-1.5212",
  "foundations-components": "static-1.8525",
  "foundations-theming": "static-1.4804",
  "hub-http": "static-1.6543",
  "hubspot-url-utils": "static-1.4297",
  "HubStyle": "static-2.12124",
  "icons": "static-2.688",
  "immutable": "static-2.83",
  "quick-fetch": "static-1.4149",
  "raven": "static-3.5925",
  "react": "static-7.196",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.75",
  "react-rhumb": "static-1.17049",
  "react-select-plus": "static-1.113",
  "react-utils": "static-2.5575",
  "react-virtualized": "static-2.107",
  "redux": "static-4.76",
  "StyleGuideUI": "static-3.505",
  "tinymce-plugins": "static-1.58257",
  "transmute": "static-2.97",
  "ui-images": "static-2.1256",
  "UIComponents": "static-3.8763",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9867",
  "styled-components": "static-2.95",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3766",
  "quartz-webpack": "static-1.3713",
  "foundations-theming-specialty": "static-1.2520",
  "property-description-translator": "static-1.4166",
  "HeadJS": "static-2.800",
  "framer-motion": "static-1.79",
  "hs-test-utils-bend-plugin": "static-1.3470",
  "msw": "static-1.39",
  "testing-library": "static-1.158",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.230",
  "moment-timezone": "static-5.91",
  "jasmine": "static-4.4641",
  "jasmine-runner": "static-1.6778",
  "opentelemetry-fe-types": "static-1.107",
  "dispatcher": "static-1.143",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.886",
  "hubspotter-http": "static-1.4883",
  "mobile-manifest-mixins": "static-1.580",
  "module-federation": "static-1.33",
  "opentelemetry-fe": "static-1.482",
  "quartz-auth": "static-1.1164",
  "quartz-head": "static-1.1154",
  "quartz-i18n": "static-1.1164",
  "quartz-routing": "static-1.919",
  "quartz-test": "static-1.1164",
  "quartz-tracking": "static-1.868",
  "trellis-components": "static-1.2725",
  "ui-fonts": "static-1.1079",
  "usage-tracker-container": "static-1.7632",
  "usage-tracker-core": "static-1.7492",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.218",
  "conversations-skeleton-state": "static-1.7576",
  "reference-resolvers": "static-1.8509",
  "sanitize-text": "static-1.8486",
  "PatternValidationJS": "static-1.3221",
  "ReduxMessenger": "static-2.10698",
  "outpost": "static-1.4482",
  "rpc-client-utils": "static-1.4995",
  "sanitize": "static-1.4800",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4795",
  "floating-ui": "static-1.63",
  "hs-story-utils": "static-1.9754",
  "react-aria": "static-1.72",
  "react-create-root-preference": "static-1.75",
  "tanstack-table": "static-1.61",
  "trellis-assets": "static-1.2706",
  "bend-plugin-foundations-theming": "static-1.3287",
  "foundations-theming-base": "static-1.3789",
  "stylex": "static-1.41",
  "hs-locale-management": "static-1.314",
  "csstype": "static-1.50",
  "web-vitals": "static-1.15",
  "ai-components-ui-library": "static-1.9765",
  "atom": "static-1.5414",
  "codemirror": "static-5.102",
  "content-assistance-lib": "static-1.8231",
  "ContentUtils": "static-1.69167",
  "data-token-picker": "static-1.16922",
  "file-manager-components": "static-1.24551",
  "FileManagerCore": "static-1.40050",
  "FileManagerLib": "static-1.40191",
  "frontend-preferences-client": "static-1.8250",
  "hub-http-contrib": "static-1.3367",
  "interframe": "static-3.5083",
  "layout-dnd-components": "static-1.13002",
  "layout-dnd-utils": "static-1.11978",
  "property-translator": "static-1.5723",
  "react-codemirror": "static-1.10970",
  "react-colorpicker": "static-2.10545",
  "reference-resolvers-lite": "static-1.8432",
  "rich-text-lib": "static-1.20338",
  "tinymce-data": "static-1.41228",
  "tinymce-themes": "static-1.57113",
  "ui-addon-emoji-picker": "static-1.10213",
  "ui-addon-sales-email": "static-1.5543",
  "ui-brand-identity-lib": "static-1.16575",
  "bender-build-tools": "static-1.3452",
  "opentelemetry-web": "static-1.15",
  "hub-http-shared-msw-handlers": "static-1.10655",
  "hubspotter-http-shared-msw-handlers": "static-1.10653",
  "usage-tracker-session-replay": "static-1.5328",
  "base-ui": "static-1.22",
  "react-day-picker": "static-1.10",
  "trellis-theming": "static-1.1304",
  "tanstack-virtual": "static-1.38",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.405",
  "chirp-fetch": "static-1.2223",
  "stylex-utils": "static-1.146",
  "chatspot-core": "static-1.23131",
  "copilot-toolkit": "static-1.11881",
  "customer-data-objects-ui-components": "static-1.13360",
  "data-fetching-client": "static-1.9984",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.5086",
  "ui-addon-video-player": "static-1.9033",
  "ui-coaching-tips": "static-1.29346",
  "usage-tracker": "static-1.7642",
  "cms-field-types": "static-1.5142",
  "content-icons-ui": "static-1.2392",
  "integrations-lib": "static-1.17088",
  "customer-data-objects": "static-1.8024",
  "breeze-engine-lib": "static-1.1799",
  "immer": "static-1.101",
  "immerable": "static-1.4477",
  "ui-addon-iframeable": "static-1.9404",
  "video-components-external": "static-1.12182",
  "video-data-lib": "static-1.35840",
  "breeze-artifacts-sdk": "static-1.414",
  "audio-components": "static-1.6376",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29846",
  "FileManagerImages": "static-1.37702",
  "html-to-image": "static-1.61",
  "redux-toolkit": "static-1.78",
  "ui-universal-auth": "static-1.9441",
  "urlinator": "static-1.4862",
  "video-components": "static-1.14184",
  "video-embed": "static-1.36674",
  "ts-schema": "static-1.4313",
  "ContentData": "static-1.69242",
  "layout-data-lib": "static-1.10303",
  "react-dnd-compat": "static-1.4944",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1873",
  "external-options-client-types": "static-1.4360",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7222",
  "hs-promise-utils": "static-1.5922",
  "inbound-db-properties-service-client": "static-1.4066",
  "NamespacedHubStyle": "static-2.9285",
  "apollo-dlb": "static-3.86",
  "apollo-stack-hubspot": "static-3.94",
  "graphql": "static-1.89",
  "growth-onboarding-confetti": "static-1.3391",
  "SharedI18nStrings": "static-1.183",
  "ui-addon-i18n": "static-1.11474",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5778",
  "magpie-types": "static-1.5238",
  "simple-logging-lib": "static-1.3379",
  "avatar-components": "static-1.2810",
  "customer-data-ui-utilities": "static-1.10160",
  "growth-onboarding-feedback-components": "static-1.6912",
  "flux-actions": "static-1.371",
  "hubspot-apollo-client": "static-1.5204",
  "integrations-error-boundary-lib": "static-1.14503",
  "integrations-tracking-lib": "static-1.5937",
  "laboratory-lib": "static-3.7481",
  "native-integrations-shared-strings": "static-1.8105",
  "redux-observable": "static-1.75",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10599",
  "unified-auth": "static-1.955",
  "breeze-engine-chat-components": "static-1.777",
  "breeze-engine-core": "static-1.1077",
  "ably": "static-2.2",
  "highlight.js": "static-1.86",
  "pulse": "static-1.957",
  "navigation-messaging": "static-1.8200",
  "apollo-link-hub-http": "static-2.4985",
  "content-media-composition-data-lib": "static-1.13286",
  "content-media-compositions": "static-2.17293",
  "idb-keyval": "static-1.51",
  "media-bridge-lib": "static-1.19436",
  "foundations-components-legacy": "static-1.1550",
  "unified-auth-core-lib": "static-1.1237",
  "social-insights-client-types": "static-1.22706",
  "advanced-menus-core": "static-1.15606",
  "advanced-menus-lib": "static-1.12480",
  "ExportDialog": "static-6.10708",
  "ui-memberships-settings-lib": "static-1.34882",
  "conditional-properties-service-client": "static-1.4036",
  "crm-pipelines-api-client-types": "static-1.4367",
  "fdsr-migration-layer": "static-1.341",
  "framework-builder-read-service-client": "static-1.4241",
  "framework-data-schema-quick-fetch": "static-1.7127",
  "inbound-db-meta-service-client": "static-1.3718",
  "multi-currency-client-types": "static-1.3928",
  "persist-promise": "static-1.4030",
  "foundations-components-test-utils": "static-1.6008",
  "reactive-lib": "static-1.1046",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.663",
  "universal-page-editor-lib": "static-1.3338",
  "adobe-sign-auth-lib": "static-1.504",
  "ads-unified-auth-lib": "static-1.1473",
  "generic-oauth-auth-lib": "static-1.83",
  "google-sheets-integration-lib": "static-1.1067",
  "microsoft-drive-auth-lib": "static-1.183",
  "surveymonkey-integration-lib": "static-1.524",
  "slack-ui-library": "static-1.10726",
  "bend-plugin-pulse": "static-1.460",
  "event-emitter": "static-1.1282",
  "fast-json-patch": "static-1.70",
  "js-cookie": "static-1.18",
  "fsm": "static-1.4080",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15605",
  "simple-menus-lib": "static-1.17122",
  "settings-ui-lib": "static-1.12852",
  "crm-record-cards-service-types": "static-1.3796",
  "location-customization-utils-lib": "static-1.10139",
  "react-flip-move": "static-1.78"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30818",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.55354",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8359",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "HubStyleTokens": "/HubStyleTokens/static-2.11817",
  "I18n": "/I18n/static-7.1678",
  "quartz": "/quartz/static-1.7489",
  "quartz-config": "/quartz-config/static-1.1267",
  "quartz-core": "/quartz-core/static-1.6708",
  "react-dlb": "/react-dlb/static-1.89",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.80",
  "reselect": "/reselect/static-3.12",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.950",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.55341",
  "feedback-utils": "/feedback-utils/static-1.55345",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4793",
  "forms-utils-lib": "/forms-utils-lib/static-1.13124",
  "foundations-assets": "/foundations-assets/static-1.5212",
  "foundations-components": "/foundations-components/static-1.8525",
  "foundations-theming": "/foundations-theming/static-1.4804",
  "hub-http": "/hub-http/static-1.6543",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "HubStyle": "/HubStyle/static-2.12124",
  "icons": "/icons/static-2.688",
  "immutable": "/immutable/static-2.83",
  "quick-fetch": "/quick-fetch/static-1.4149",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.196",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.75",
  "react-rhumb": "/react-rhumb/static-1.17049",
  "react-select-plus": "/react-select-plus/static-1.113",
  "react-utils": "/react-utils/static-2.5575",
  "react-virtualized": "/react-virtualized/static-2.107",
  "redux": "/redux/static-4.76",
  "StyleGuideUI": "/StyleGuideUI/static-3.505",
  "tinymce-plugins": "/tinymce-plugins/static-1.58257",
  "transmute": "/transmute/static-2.97",
  "ui-images": "/ui-images/static-2.1256",
  "UIComponents": "/UIComponents/static-3.8763",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9867",
  "styled-components": "/styled-components/static-2.95",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3766",
  "quartz-webpack": "/quartz-webpack/static-1.3713",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2520",
  "property-description-translator": "/property-description-translator/static-1.4166",
  "HeadJS": "/HeadJS/static-2.800",
  "framer-motion": "/framer-motion/static-1.79",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3470",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.158",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.230",
  "moment-timezone": "/moment-timezone/static-5.91",
  "jasmine": "/jasmine/static-4.4641",
  "jasmine-runner": "/jasmine-runner/static-1.6778",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.107",
  "dispatcher": "/dispatcher/static-1.143",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.886",
  "hubspotter-http": "/hubspotter-http/static-1.4883",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.580",
  "module-federation": "/module-federation/static-1.33",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.482",
  "quartz-auth": "/quartz-auth/static-1.1164",
  "quartz-head": "/quartz-head/static-1.1154",
  "quartz-i18n": "/quartz-i18n/static-1.1164",
  "quartz-routing": "/quartz-routing/static-1.919",
  "quartz-test": "/quartz-test/static-1.1164",
  "quartz-tracking": "/quartz-tracking/static-1.868",
  "trellis-components": "/trellis-components/static-1.2725",
  "ui-fonts": "/ui-fonts/static-1.1079",
  "usage-tracker-container": "/usage-tracker-container/static-1.7632",
  "usage-tracker-core": "/usage-tracker-core/static-1.7492",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.218",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7576",
  "reference-resolvers": "/reference-resolvers/static-1.8509",
  "sanitize-text": "/sanitize-text/static-1.8486",
  "PatternValidationJS": "/PatternValidationJS/static-1.3221",
  "ReduxMessenger": "/ReduxMessenger/static-2.10698",
  "outpost": "/outpost/static-1.4482",
  "rpc-client-utils": "/rpc-client-utils/static-1.4995",
  "sanitize": "/sanitize/static-1.4800",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4795",
  "floating-ui": "/floating-ui/static-1.63",
  "hs-story-utils": "/hs-story-utils/static-1.9754",
  "react-aria": "/react-aria/static-1.72",
  "react-create-root-preference": "/react-create-root-preference/static-1.75",
  "tanstack-table": "/tanstack-table/static-1.61",
  "trellis-assets": "/trellis-assets/static-1.2706",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3287",
  "foundations-theming-base": "/foundations-theming-base/static-1.3789",
  "stylex": "/stylex/static-1.41",
  "hs-locale-management": "/hs-locale-management/static-1.314",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.15",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9765",
  "atom": "/atom/static-1.5414",
  "codemirror": "/codemirror/static-5.102",
  "content-assistance-lib": "/content-assistance-lib/static-1.8231",
  "ContentUtils": "/ContentUtils/static-1.69167",
  "data-token-picker": "/data-token-picker/static-1.16922",
  "file-manager-components": "/file-manager-components/static-1.24551",
  "FileManagerCore": "/FileManagerCore/static-1.40050",
  "FileManagerLib": "/FileManagerLib/static-1.40191",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8250",
  "hub-http-contrib": "/hub-http-contrib/static-1.3367",
  "interframe": "/interframe/static-3.5083",
  "layout-dnd-components": "/layout-dnd-components/static-1.13002",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11978",
  "property-translator": "/property-translator/static-1.5723",
  "react-codemirror": "/react-codemirror/static-1.10970",
  "react-colorpicker": "/react-colorpicker/static-2.10545",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8432",
  "rich-text-lib": "/rich-text-lib/static-1.20338",
  "tinymce-data": "/tinymce-data/static-1.41228",
  "tinymce-themes": "/tinymce-themes/static-1.57113",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10213",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5543",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16575",
  "bender-build-tools": "/bender-build-tools/static-1.3452",
  "opentelemetry-web": "/opentelemetry-web/static-1.15",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10655",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10653",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5328",
  "base-ui": "/base-ui/static-1.22",
  "react-day-picker": "/react-day-picker/static-1.10",
  "trellis-theming": "/trellis-theming/static-1.1304",
  "tanstack-virtual": "/tanstack-virtual/static-1.38",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.405",
  "chirp-fetch": "/chirp-fetch/static-1.2223",
  "stylex-utils": "/stylex-utils/static-1.146",
  "chatspot-core": "/chatspot-core/static-1.23131",
  "copilot-toolkit": "/copilot-toolkit/static-1.11881",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13360",
  "data-fetching-client": "/data-fetching-client/static-1.9984",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.5086",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9033",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29346",
  "usage-tracker": "/usage-tracker/static-1.7642",
  "cms-field-types": "/cms-field-types/static-1.5142",
  "content-icons-ui": "/content-icons-ui/static-1.2392",
  "integrations-lib": "/integrations-lib/static-1.17088",
  "customer-data-objects": "/customer-data-objects/static-1.8024",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1799",
  "immer": "/immer/static-1.101",
  "immerable": "/immerable/static-1.4477",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9404",
  "video-components-external": "/video-components-external/static-1.12182",
  "video-data-lib": "/video-data-lib/static-1.35840",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.414",
  "audio-components": "/audio-components/static-1.6376",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29846",
  "FileManagerImages": "/FileManagerImages/static-1.37702",
  "html-to-image": "/html-to-image/static-1.61",
  "redux-toolkit": "/redux-toolkit/static-1.78",
  "ui-universal-auth": "/ui-universal-auth/static-1.9441",
  "urlinator": "/urlinator/static-1.4862",
  "video-components": "/video-components/static-1.14184",
  "video-embed": "/video-embed/static-1.36674",
  "ts-schema": "/ts-schema/static-1.4313",
  "ContentData": "/ContentData/static-1.69242",
  "layout-data-lib": "/layout-data-lib/static-1.10303",
  "react-dnd-compat": "/react-dnd-compat/static-1.4944",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1873",
  "external-options-client-types": "/external-options-client-types/static-1.4360",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7222",
  "hs-promise-utils": "/hs-promise-utils/static-1.5922",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4066",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9285",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "graphql": "/graphql/static-1.89",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3391",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.183",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11474",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5778",
  "magpie-types": "/magpie-types/static-1.5238",
  "simple-logging-lib": "/simple-logging-lib/static-1.3379",
  "avatar-components": "/avatar-components/static-1.2810",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10160",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6912",
  "flux-actions": "/flux-actions/static-1.371",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5204",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14503",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5937",
  "laboratory-lib": "/laboratory-lib/static-3.7481",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8105",
  "redux-observable": "/redux-observable/static-1.75",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10599",
  "unified-auth": "/unified-auth/static-1.955",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.777",
  "breeze-engine-core": "/breeze-engine-core/static-1.1077",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.86",
  "pulse": "/pulse/static-1.957",
  "navigation-messaging": "/navigation-messaging/static-1.8200",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4985",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13286",
  "content-media-compositions": "/content-media-compositions/static-2.17293",
  "idb-keyval": "/idb-keyval/static-1.51",
  "media-bridge-lib": "/media-bridge-lib/static-1.19436",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1550",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1237",
  "social-insights-client-types": "/social-insights-client-types/static-1.22706",
  "advanced-menus-core": "/advanced-menus-core/static-1.15606",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12480",
  "ExportDialog": "/ExportDialog/static-6.10708",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34882",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4036",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4367",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.341",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4241",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7127",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3928",
  "persist-promise": "/persist-promise/static-1.4030",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6008",
  "reactive-lib": "/reactive-lib/static-1.1046",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.663",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3338",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.504",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1473",
  "generic-oauth-auth-lib": "/generic-oauth-auth-lib/static-1.83",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1067",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.183",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.524",
  "slack-ui-library": "/slack-ui-library/static-1.10726",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.460",
  "event-emitter": "/event-emitter/static-1.1282",
  "fast-json-patch": "/fast-json-patch/static-1.70",
  "js-cookie": "/js-cookie/static-1.18",
  "fsm": "/fsm/static-1.4080",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15605",
  "simple-menus-lib": "/simple-menus-lib/static-1.17122",
  "settings-ui-lib": "/settings-ui-lib/static-1.12852",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3796",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10139",
  "react-flip-move": "/react-flip-move/static-1.78"
}
};
